const convertMeterToCentimeter = (meter: number): string => {
  const result = (meter / 100).toFixed(1)

  return result
}

export { convertMeterToCentimeter }
